import { useTranslations } from "./i18n/utils";
import { SiteConfig } from "./interfaces/SiteConfig";

export const CONFIG_OPTIONS: SiteConfig = globalThis.CONFIG_OPTIONS;
export const CURRENT_LANG = globalThis.CURRENT_LANG;

export const t = useTranslations(CURRENT_LANG);
